import React, { useState } from "react";
import { Button, Input, Form, notification } from "antd";
import { useNavigate } from "react-router-dom";
import { login } from "../api/Auth";
import "../styles/Login.css";
import cover_login from "../assets/cover-login.jpg";

const LoginPage = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const { username, password } = values;
      const userData = await login(username, password);

      if (userData[0].status) {
        sessionStorage.setItem("user", JSON.stringify(userData));
        navigate("/dashboard");
      } else {
        notification.error({
          message: "Error",
          description: userData[0].message,
        });
      }
    } catch (error) {
      notification.error({
        message: "Error",
        description: error.message,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="left-side">
        <img src={cover_login} alt="Payroll App" />
      </div>
      <div className="right-side">
        <h2>Payroll Application</h2>
        <h5>LOGIN HERE!</h5>
        <Form className="card" onFinish={onFinish}>
          <Form.Item
            name="username"
            rules={[{ required: true, message: "Masukkan username!" }]}
          >
            <Input placeholder="Username" />
          </Form.Item>
          <Form.Item
            name="password"
            rules={[{ required: true, message: "Masukkan password!" }]}
          >
            <Input.Password placeholder="Password" />
          </Form.Item>
          <Form.Item>
            <Button
              className="login-button"
              type="success"
              block
              htmlType="submit"
              loading={loading}
            >
              Login
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};

export default LoginPage;
